import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {
  AngularMaterialModule,
  DashboardsModule,
  DataSourceItemsModule,
  DataSourceModule,
  FiltersModule,
  SmartGridModule,
  ToggleGroupNavigationModule,
  UserSettingsLibModule,
} from '@suvo-bi-lib';
import { SubscriptionModule } from '@suvo-bi-users';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SharedModule } from '../../../shared/shared.module';
import { NavigationOutletModule } from '../customer-navigation/components/navigation-outlet/navigation-outlet.module';
import { CustomerNavigationModule } from '../customer-navigation/customer-navigation.module';
import { DashboardScreenComponent } from './screens/dashboard-screen/dashboard-screen.component';
import { EmailAlertsButtonComponent } from './components/email-alerts-button/email-alerts-button.component';
import { DashboardBreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { PublicDashboardScreenComponent } from './screens/public-dashboard-screen/public-dashboard-screen.component';
import { environment } from '@environments/environment';
import { DataSourceItemViewsModule } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/data-source/data-source-item-views/data-source-item-views.module';

@NgModule({
  declarations: [
    DashboardScreenComponent,
    EmailAlertsButtonComponent,
    DashboardBreadcrumbsComponent,
    PublicDashboardScreenComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FiltersModule,
    SmartGridModule,
    NgxChartsModule,
    NgxSkeletonLoaderModule,
    ToggleGroupNavigationModule,
    UserSettingsLibModule,
    DataSourceModule,
    DataSourceItemViewsModule,
    DataSourceItemsModule,
    SubscriptionModule,
    ReactiveFormsModule,
    NavigationOutletModule,
    AngularMaterialModule,
    CustomerNavigationModule,
    DashboardsModule.forRoot(environment),
  ],
  exports: [DashboardScreenComponent, PublicDashboardScreenComponent],
})
export class CustomerDashboardsModule {}
